import { Typography, Box, Divider } from '@mui/material';
import React, { useEffect, useState, Fragment, useContext } from 'react';
import { GetCompanyAPI } from '../../api/company/getCompany';
import Loader from '../../components/loader/loader';
import { AuthorizationContext } from '../../context/authorizationContext';
import "./company.css";

const Company = ()=>{

    const [company, setCompany] = useState(null);
    const [users, setUsers] = useState(null);
    const [flagLoader, setFlagLoader] = useState(false);
    const { setPath } = useContext(AuthorizationContext);
    
    setPath(window.location.pathname);

    useEffect(()=>{
        setFlagLoader(true);
        GetCompanyAPI({}, (res)=>{
            setFlagLoader(false);
            console.log("Printing response for get company", res);

            if(res.data.status === true){
                setCompany(res.data.company);
                setUsers(res.data.users);
            }
            else{
                alert("Something went wrong, Please try again later.!")
            }
        }, (err)=>{
            setFlagLoader(false);
            console.log("Printing error for get comoany", err);
            alert("Something went wrong, Please try again later.!")
        })
    }, [])

    return (
        <Fragment>
            {flagLoader === true && <Loader />}
            <Typography variant="h4" style={{textAlign: "center", margin: "10px", color: "#624dff"}}>Company Details:</Typography>
            {company !== null && <Box style={{padding: "10px"}}>
                <Typography variant="h6">Company Name: <span style={{color: "#624dff"}}>{company?.company_name}</span></Typography>
                <Typography variant="h6">Company Website: <a href={company?.company_website} target="_blank" style={{color: "#624dff", textDecoration: "none"}}>{company?.company_website}</a></Typography>
                <Typography variant="h6">Company Contact Number: <span style={{color: "#624dff"}}>{company?.company_contact_number}</span></Typography>
                <Typography variant="h6">Company Email Address: <a href={`mailto:${company?.company_email_address}`} target="_blank" style={{color: "#624dff"}}>{company?.company_email_address}</a></Typography>
                <Typography variant="h6">Company Address: <span style={{color: "#624dff"}}>{company?.company_address}</span></Typography>
            </Box>}
            <Divider style={{margin: "0 10px"}} />
            <Typography variant="h4" style={{textAlign: "center", margin: "10px", color: "#624dff"}}>Employee Details:</Typography>
            <Box style={{display: "flex", justifyContent: "space-around", alignItems: "center", flexWrap: "wrap"}}>
            {users !== null && users.map((emp, i)=>{
                return (
                    <Box className="employee_detail" style={{margin: "15px"}} key={i}>
                        <Typography variant="h6">Name: <span style={{color: "#624dff"}}>{emp?.first_name} {emp?.last_name}</span></Typography>
                        <Typography variant="h6">Email: <span style={{color: "#624dff"}}>{emp?.email}</span></Typography>
                        <Typography variant="h6">Phone: <span style={{color: "#624dff"}}>{emp?.phone}</span></Typography>
                        <Typography variant="h6">Admin: <span style={{color: "#624dff"}}>{emp?.admin === true ? "Yes" : "No"}</span></Typography>
                    </Box>
                )
            })}
            </Box>
        </Fragment>
    )
};

export default Company;